










import {defineComponent, PropType} from "@vue/composition-api"
import {IPortalSubtopic} from "@/apps/PortalTopicWidget/models/portal-topic-widget-state";
import PortalSubtopicComponent from "@/apps/PortalTopicWidget/components/PortalSubtopicComponent.vue";

export default defineComponent({
  name: "PortalTopicWidget",
  components: {
    PortalSubtopicComponent
  },
  props: {
    title: {type: String, required: true},
    introText: {type: String, required: true},
    subtopics: {type: Array as PropType<IPortalSubtopic[]>, required: true},
  }
})
